<template>
  <div class="absolute fill-height events-page">
    <v-snackbar v-model="ok_snackbar" :timeout="3000" color="green darken-3 white--text" :top="true">
      {{ ok_text }}
      <v-btn color="white" flat @click="ok_snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="error_snackbar" :timeout="3000" color="red darken-3 white--text" :top="true">
      {{ error_text }}
      <v-btn color="white" flat @click="error_snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>Párování spolupracovníků s klientskými účty</h3>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>
                    <router-link :to="{ path: '/spolupracovnici/' + props.item.id }" target="_blank">
                      {{ props.item.osoba.nazev_osoby }}
                    </router-link>
                  </td>
                  <td>
                    <clientsearch label="Klients" v-model="props.item.osoba_pro_parovani_id" class="mx-2" :klient="true" :spolupracovnik="false" @changed="(e) => { props.item.parovani_osoba = e; }"></clientsearch>
                  </td>
                  <td>
                    <router-link :to="{ path: '/spolupracovnici/' + props.item.parovani_osoba.id }" target="_blank" v-if="props.item.parovani_osoba != null">
                      {{ props.item.parovani_osoba.nazev_osoby }}
                    </router-link>
                  </td>
                </template>
              </v-data-table>
            </div>
            <v-layout row wrap class="mt-5 mb-5 text-xs-center">
              <v-flex xs12>
                <v-btn color="primary" @click="save" class="ma-0" depressed :loading="saving" large>Uložit párování</v-btn>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      updateItem: {},
      headers: [
        { text: 'ID', value: 'id', width: '30px' },
        { text: 'Spolupracovník', value: 'osoba.nazev_osoby' },
        { text: 'Klient', value: 'cislo_pozice', width: 400 },
        { text: 'Bude párováno na osobu ', value: 'cislo_pozice', width: 400 },
      ],
      loadingTable: true,
      search: "",
      items: [],
      dialog: false,
      pozice: [ "I.", "II.", "III.", "IV.", "V.", "VI.", "VII." ],
      saving: false
    }
  },
  computed: {
    th () {
      return window.th;
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  watch: {

  },
  methods: {
    load: function(f) {
      this.loadingTable = true;
      window.API.get("osoby/parovani/seznam").then(function(body) {
        this.items.replace(body);
        this.loading = false;
        this.loadingTable = false;
        if (typeof f === "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    save () {
      this.saving = true;
      window.API.post("osoby/parovani/seznam", {
        osoby: this.items.map((e) => {
          return {
            osoba: {
              id: e.id
            },
            osoba_pro_parovani_id: e.osoba_pro_parovani_id
          };
        })
      }).then(function(body) {
        if (body.status) {
          this.load(() => {
            this.saving = false;
            this.ok("Párování bylo uloženo");
          });
        }
        else {
          this.saving = false;
          this.error("Párování nebylo uloženo");
        }
      }.bind(this)).catch(function(err) {
        this.saving = false;
        this.error("Párování nebylo uloženo");
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/TestTools/NastaveniParovani.vue